<template>
  <div class="form__group">
    <label
      class="block"
      :class="[themes_labes[theme]]"
      :for="name"
      v-if="label"
    >
      <span v-html="label"></span>
    <span v-if="required" class="obligatoire">*</span>
    </label>

    <textarea
      autocomplete="off"
      class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none"
      :class="[
        themes[theme],
        { 'font-mono': monospaced, form__error: hasError },
        scrollable ? 'scrollable' : ''
      ]"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :value="value"
      :rows="rows"
      @input="$emit('input', $event.target.value)"
      @keypress="prevent"
      ref="textarea"
    ></textarea>
    <div v-if="maxWords" class="text-right relative text-xs max-words">
      Mots: <span class="font-bold">{{counts.words}}</span>
    </div>
    <div class="form__control--meta" v-if="help || errorMessage">
      <div class="form__help">
        <span v-if="help" v-html="help"></span>
        <span
          v-if="errorMessage"
          class="form__error--message"
          v-html="errorMessage"
        ></span>
      </div>
    </div>
    
    <vue-countable
        :text="value == null ? 'null' :  value " 
        :elementId="'countable_short_bio'" 
        @change="changeWords"
    ></vue-countable>
  </div>
</template>
<style>
.max-words {
  top: -15px;
}

.scrollable {
  overflow-y: scroll!important;
  height: 120px!important;
}
</style>

<script>
import autosize from 'autosize';
import VueCountable from 'vue-countable';
export default {
  name: "sp-textarea",
   components: {
      'vue-countable': VueCountable
    },
  data() {   
    return {
      counts:0,
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3"
      }

    };
  },

  props: {
    name: String,
    placeholder: String,
    label: String,
    help: String,
    scrollable: Boolean,
    value: {
      type: [String, Number],
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    monospaced: {
      type: Boolean,
      default: false
    },
    hasError: {
      required: false,
      type: Boolean,
      default: false
    },
    errorMessage: {
      required: false,
      type: String,
      default: ""
    },
    rows: {
      required: false,
      type: Number,
      default: 3
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    resized:{
      type: Boolean|String,
      required :false,
      default: true
    },
    maxWords:{
      type: String|Number,
      required: false,
      default: null
    },
    maxlength:{
      type: String|Number,
      required: false,
      default: null
    }
    
  },
    mounted() {
    autosize(this.$refs.textarea)
  },
  methods: {
    prevent(event){
      if(this.maxWords && this.counts.words>=this.maxWords) event.preventDefault();
      return true;
    },
    changeWords (event) {
      this.counts = Object.assign({}, this.counts, event)
    }
  }
 
};
</script>
